import { LINK_TYPE, LINK_DISPLAY_NAME } from './linkConstants';
import { registerElementType } from '../elements/elementRegistry';
import elementConstructor from '../elements/elementConstructor';

const objectConstructorFn = (params) => {
    const { content } = params;
    return {
        ...elementConstructor(params),
        elementType: LINK_TYPE,
        content: {
            url: null,
            ...content,
        },
    };
};

export default (params = {}) =>
    registerElementType({
        elementType: LINK_TYPE,
        objectConstructorFn,
        displayName: LINK_DISPLAY_NAME,
        ...params,
    });
